import { createSlice } from "@reduxjs/toolkit";
import { MENU_ITEMS_KEY } from "../../constants/appConstants";

const initialState = {
    items: [],
    isLoaded: false
}

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMenuItems: (state, { payload }) =>
        {
            state.items = payload;
            localStorage.setItem(MENU_ITEMS_KEY, JSON.stringify(payload));
            state.isLoaded = true;
        },
        clearMenuItems: (state) =>
        {
            state.items = [];
            localStorage.removeItem(MENU_ITEMS_KEY);
        },
        isMenuLoaded: (state) =>
        {
            const items = localStorage.getItem(MENU_ITEMS_KEY);
            if (items != null)
            {
                state.isLoaded = true;
            }
            state.isLoaded = false;
        }
    }
});

export const { setMenuItems, clearMenuItems, isMenuLoaded } = menuSlice.actions;
export default menuSlice.reducer;